import { AgdysaIcon } from '@agdysa/icons'

/** Icono de marca AGDYSA por ID de catálogo — color estándar #3C7C3C */
export function BrandIcon({ id, size = 36, className = 'text-brand-icon' }) {
  return <AgdysaIcon id={id} size={size} className={className} />
}
